import React, { useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import {
    AlertType, Produto, classDivBackground, classInput, classLabel, classInputDark,
    classLabelDark, classbtAzul, classBt, AcertoEstoque, classBorderLabelDark,
    classDivBody, classbtCinzaClaro, KEY_CODE_ENTER, classDivTitulo, InputsRefs, classWeigthBt
} from '../../Utils/Types'
import { IoCameraOutline, IoSave, IoSearch } from 'react-icons/io5'
import { ProdutoService } from '../Products/ProdutoService'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { AcertoEstoqueService } from './AcertoEstoqueService'
import { AiOutlineClear } from 'react-icons/ai'
import { MdEditDocument } from 'react-icons/md'
import { ModalLancaGradeProdutos } from '../../Components/Modal/modal-lanca-grad-produtos'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'
import { FaVideo } from 'react-icons/fa'

export const LancaAcertoEstoque = () => {

    const [loading, setLoading] = useState(false)
    const [loadingPesq, setLoadingPesq] = useState(false)
    const [visible, setVisible] = useState(false)
    const [visibleModalGrade, setVisibleModalGrade] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")
    const [isGrade, setIsGrade] = useState(false)
    const [produtosList, setProdutosList] = useState<Produto[]>([])
    const [produtosDefault, setProdutosDefault] = useState<Produto[]>([])
    const [idProdSelecionado, setIdProdSelecionado] = useState(0)
    const [descProd, setDescProd] = useState("")
    const [tipo, setTipo] = useState("E")
    const [saldo, setSaldo] = useState("")
    const [observacao, setObservacao] = useState("")
    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(-1)
    //const [gradeSelecionada, setGradeSelecionada]   = useState<GradeProduto>()

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    // ---------------------------------------------------------------------------- INPUTS --------------------------------------------------------------------
    const handleChangeDescProd = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescProd(e.target.value)
        setProdutosList([])
        setIdProdSelecionado(0)
        //setDescProdCopy('')
        setLinhaSelecionada(-1)
    }

    const handleChangeTipo = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipo(e.target.value)
    }

    const handleChangeSaldo = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSaldo(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeObs = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }

    // ------------------------------------------------------------------------- USE-EFFECT ---------------------------------------------------------------------
    useEffect(() => {
        Inputfocus()
    }, []);

    /*
    useEffect(() => {

        setProdutosList([]);

        if (descProdCopy === '') {

            const delayDebounceFn = setTimeout(() => {

                if (descProd && descProd.length > 0) {

                    ProdutosFilter()  // Chama a função após 500 segundos de inatividade
                } else {

                    setProdutosList([])
                }
            }, 500) // 500 segundos

            setIdProdSelecionado(0)

            return () => clearTimeout(delayDebounceFn)

        } else {

            setDescProdCopy("")
            setLinhaSelecionada(-1)

        }

    
        if (descProdCopy === '') {

            if (descProd.trim().length > 0 && (descProd.trim().length % 4) === 0) {
                ProdutosFilter()
            } else if (descProd.trim().length == - 0) {
                setProdutosList([])
            }

        } else {
            setDescProdCopy("")
        }
            

    }, [descProd])
    */

    useEffect(() => {

        const inputElement = document.getElementById("pesquisa")

        const handleKeyDown = (event: any) => {

            const { key } = event;

            if (key === 'ArrowUp' || key === 'ArrowDown') {
                event.preventDefault()

                let nextIndex;
                if (key === 'ArrowUp') {
                    nextIndex = linhaSelecionada === -1 || linhaSelecionada === 0 ? produtosList.length - 1 : linhaSelecionada - 1;
                } else {
                    nextIndex = linhaSelecionada < produtosList.length - 1 ? linhaSelecionada + 1 : 0;
                }

                const selectedItem = produtosList[nextIndex];

                if (selectedItem != undefined) {

                    handleSetProdMove(selectedItem, nextIndex)
                    setLinhaSelecionada(Math.max(0, Math.min(nextIndex, produtosList.length - 1)))

                    // Scroll into view
                    const element = document.getElementById(`produto-grade-${nextIndex}`);
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        });
                    }

                } else {
                    setLinhaSelecionada(-1)
                    //setProdutosList([])
                }
            }

        }

        const handleKeyPressEnter = (event: any) => {

            if ((event.code === KEY_CODE_ENTER || event.code === "NumpadEnter") && document.activeElement === inputElement && !loadingPesq) {

                if (produtosList.length > 0 && linhaSelecionada !== -1) {

                    condicaoAbrirModal(idProdSelecionado)

                    //setDescProd(descProdCopy)
                    setProdutosList([])
                    setLinhaSelecionada(-1)

                } else {
                    ProdutosFilter()
                }
            }

        }

        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [linhaSelecionada, produtosList, descProd, loadingPesq, idProdSelecionado])


    // ------------------------------------------------------------------------- FILTROS -------------------------------------------------------------------------
    const ProdutosFilter = async () => {

        setLoadingPesq(true)
        setVisible(false)
        setProdutosList([])

        try {

            const relatorio = {
                status: 'S',
            }

            const produtos = await ProdutoService.Filter('descricao', descProd, 'start', relatorio);
            setProdutosList(produtos.data)
            setProdutosDefault(produtos.data)

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possível buscar os produtos')

        } finally {
            Inputfocus()
            setLoadingPesq(false)
        }
    }

    const handleSetProdClick = (item: any, index: number) => {
        setIdProdSelecionado(item.id)
        setDescProd(item.descricao)

        condicaoAbrirModal(item.id)

        setProdutosList([])
        setLinhaSelecionada(-1)
    }

    const handleSetProdMove = (item: any, index: number) => {
        setIdProdSelecionado(item.id)
        setDescProd(item.descricao)
        //setDescProdCopy(item.descricao)
        setLinhaSelecionada(index)
    }

    const handleClearFields = () => {
        setDescProd("")
        setIdProdSelecionado(0)
        //setDescProdCopy("")
        setTipo("E")
        setSaldo("")
        setObservacao("")
        Inputfocus()
        setVisible(false)
        setLinhaSelecionada(-1)
        fecharListaProduto()
    }

    const fecharListaProduto = () => {
        setProdutosList([])
        //setIdProdSelecionado(0)
        //setDescProdCopy('')
        setLinhaSelecionada(-1)
    }

    // ------------------------------------------------------------------------- API--------------------------------------------------------------------------------
    const handleSaveAcerto = async () => {

        setVisible(false)
        setLoading(true)
        fecharListaProduto()

        try {
 
            const acertoEstoque: AcertoEstoque = {
                idProduto: idProdSelecionado,
                qtd: parseFloat(saldo),
                observacao: observacao,
                tipo: tipo,
            }

            const retApi = await AcertoEstoqueService.Save(acertoEstoque)

            if (retApi.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retApi.msg || '')

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage('Lançamento efetuado com sucesso')

                setTipo("E")
                setSaldo("")
                setIdProdSelecionado(0)
                setObservacao("")
                setDescProd("")
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage('Não foi possivel completar o lançamento do estoque. Por favor, tente novamente')

        } finally {
            setLoading(false)
            Inputfocus()
        }
    }

    // ------------------------------------------------------------------------- FUNÇÕES DE FOCUS E MENSAGEM --------------------------------------------------------
    const handleCloseMessage = () => {
        setMessage("")
        setVisible(false)
    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa")
        inputElement?.focus()
    }

    // ---------------------------------------------------------------- FOCUS -----------------------------------------------------------------
    const visibleModalGradeRef = useRef(visibleModalGrade)

    useEffect(() => {
        visibleModalGradeRef.current = visibleModalGrade
    }, [visibleModalGrade])

    const inputsRefs: InputsRefs = {
        nomeProd: useRef(null),
        tipoLancamento: useRef(null),
        saldoEstoque: useRef(null),
        observacao: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && !visibleModalGradeRef.current) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            condicaoAbrirModal(idProdSelecionado)

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    // ---------------------------------------------------------------- MODAL -----------------------------------------------------------------
    const fecharModalGrade = () => {
        setDescProd("")
        setIdProdSelecionado(0)
        setTipo("E")
        setSaldo("")
        setObservacao("")
        Inputfocus()
        setVisible(false)
        setLinhaSelecionada(-1)
        fecharListaProduto()
        setVisibleModalGrade(false)
    }

    const handleGradeSelecionadaClick = () => {
        setDescProd("")
        setIdProdSelecionado(0)
        setTipo("E")
        setSaldo("")
        setObservacao("")
        Inputfocus()
        setVisible(false)
        setLinhaSelecionada(-1)
        fecharListaProduto()
        setVisibleModalGrade(false)
    }

    const condicaoAbrirModal = (idProduto: any) => {


        if (idProduto > 0) {
            const newProdutosList = [...produtosDefault]
            const prods: Produto[] = newProdutosList.filter(item => item.id === idProduto)
            if (prods && prods.length > 0) {
                setIsGrade(prods[0].isGrade || false)
            } else {
                setIsGrade(false)
            }
            setVisibleModalGrade(prods[0].isGrade || false)
        }
    }

    // ------------------------------------------------------------------------- FUNÇÕES SEM USO -------------------------------------------------------------------
    const handleFilterProd = () => {
        //setProdutosList([])
        //if (descProd.trim().length > 0) {
        //ProdutosFilter()
        //}
    }

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} mb-1`}>

                        <div className={`flex items-center w-full`}>

                            <MdEditDocument className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Acertos de Estoque</span>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} max-w-[150px] h-9 shadow-md shadow-blue-600 mx-2`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>
                    </div>

                    <div className={`w-full h-auto min-h-[60px] grid gap-4 grid-cols-12 items-center rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 p-2`}>

                        <div className={`relative col-span-12 md:col-span-6 xl:col-span-8 mt-4`}>

                            <div className={`flex w-full h-[45px] items-center`}>

                                <div className={`flex items-center justify-center`}>
                                    <button className={`absolute h-[43px] w-10 right-[1px] z-10 border bg-slate-300 hover:bg-slate-600 transition-colors duration-300 border-slate-400 border-y-0 border-r-0 dark:bg-slate-500 dark:hover:bg-slate-800 dark:border-slate-700 dark:focus:border-slate-400" rounded-r-md `} onClick={ProdutosFilter}>
                                        <div className={`w-full h-full flex justify-center items-center text-slate-700 hover:text-slate-300 dark:text-slate-100`}>
                                            {!loadingPesq &&
                                                <IoSearch className={`h-[18px] w-[18px]`} />
                                            }
                                            {loadingPesq &&

                                                <div className={`z-10 absolute mx-2 inline-block h-[18px] w-[18px] animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-blue-400 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                        </div>
                                    </button>
                                </div>

                                <div className={`relative w-full`}>

                                    <input ref={inputsRefs.nomeProd} onKeyDown={(e) => handleTabPress(e, 'nomeProd')} id='pesquisa' className={`${classInput} ${classInputDark} w-full pr-14`} placeholder='Digite o nome do produto e pressione Enter ou clique na lupa para buscar o produto' value={descProd} autoComplete='off' onChange={handleChangeDescProd} />
                                    <label htmlFor="pesquisa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Nome do Produto</label>

                                    {produtosList.length > 0 &&

                                        <div className={`absolute z-20 w-full min-h-[100px] max-h-[600px] overflow-y-auto bg-white dark:bg-slate-600 border border-slate-200 dark:border-slate-800 rounded-md`}>

                                            <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                                <ul id='elementos' className={`w-full`}>

                                                    {produtosList.map((item, index) => {
                                                        return (

                                                            <li key={item.id} id={`produto-grade-${index}`} onClick={() => handleSetProdClick(item, index)} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border-2 ${index === linhaSelecionada ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} cursor-pointer`}>

                                                                <div className={`w-full flex flex-row h-[48px] font-mono border border-x-0 border-t-0 border-b-slate-300 dark:border-b-slate-800`}>

                                                                    <div className={`flex items-center w-[10%] break-all `}>
                                                                        {item.urlImage &&
                                                                            <img alt='' className={`w-12 h-10 mx-1 bg-white`} src={item.urlImage} />
                                                                        }
                                                                        {!item.urlImage &&
                                                                            <IoCameraOutline className={`w-12 h-10 mx-1 text-slate-300`} />
                                                                        }
                                                                    </div>

                                                                    <div className={`flex items-center text-sm w-[70%] break-all `}>
                                                                        <span className={`px-2`}>{item.descricao.trim()}</span>
                                                                    </div>

                                                                    <div className={`flex items-center justify-end text-sm w-[20%] `}>
                                                                        <span className={`px-2`}>{`Estoque Físico: ${item.estoque_fisico}`}</span>
                                                                    </div>

                                                                </div>

                                                            </li>
                                                        )
                                                    })
                                                    }

                                                </ul>

                                            </div>

                                        </div>
                                    }
                                </div>

                            </div>

                        </div>

                        <div className={`relative col-span-12 sm:col-span-5 md:col-span-3 xl:col-span-2 mt-4`}>
                            <select ref={inputsRefs.tipoLancamento} onKeyDown={(e) => handleTabPress(e, 'tipoLancamento')} id='tipo' className={`${classInput} ${classInputDark}`} value={tipo} onFocus={fecharListaProduto} onChange={handleChangeTipo}>
                                <option value="E">Entrada</option>
                                <option value="S">Saída</option>
                            </select>
                            <label htmlFor="tipo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Tipo do Lançamento</label>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-7 md:col-span-3 xl:col-span-2 mt-4`}>
                            <input ref={inputsRefs.saldoEstoque} onKeyDown={(e) => handleTabPress(e, 'saldoEstoque')} id='saldo' className={`${classInput} ${classInputDark} first-letter:h-[40px] text-right`} type='text' inputMode='numeric' placeholder='0' autoComplete='off' value={saldo} onFocus={fecharListaProduto} onChange={handleChangeSaldo} />
                            <label htmlFor="saldo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Saldo do Estoque</label>
                        </div>

                        <div className={`relative w-full col-span-12 mt-2 mr-2`}>
                            <textarea ref={inputsRefs.observacao} onKeyDown={(e) => handleTabPress(e, 'observacao')} id="obs" className={`${classInput} ${classInputDark} w-full h-[300px] resize-none`} autoComplete='off' value={observacao} onFocus={fecharListaProduto} onChange={handleChangeObs} />
                            <label htmlFor="obs" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                        </div>

                        <div className={`flex justify-end relative w-full col-span-12 mt-2 mr-2`}>

                            <button tabIndex={-1} className={`${classBt} ${classbtCinzaClaro} max-w-[150px] mr-2`} onClick={handleClearFields}>
                                <AiOutlineClear size="18px" className={`mr-[5px]`} /><span className='mx-1'>Limpar Campos</span>
                            </button>

                            <button tabIndex={-1} className={`${classBt} ${classbtAzul} max-w-[150px] ml-2`} onClick={handleSaveAcerto}>
                                <IoSave size="18px" className={`mr-[5px]`} /><span className='mx-1'>Salvar</span>
                            </button>
                        </div>

                    </div>

                </div>

                <ModalLancaGradeProdutos
                    visible={visibleModalGrade}
                    loading={loading}
                    idProd={idProdSelecionado}
                    LancamentoEfetuadoAcertoEstoqueClick={handleGradeSelecionadaClick}
                    closeModalEvent={fecharModalGrade}
                />

                {modalTutorialVisible &&
                    <ModalTutorial
                        linkVideo='/tutorial_acertoEstoque.mp4'
                        title='Como realizar um acerto de estoque'
                        visible={modalTutorialVisible}
                        onCloseClick={() => setModalTutorialVisible(false)}
                    />
                }
            </div>



        </Template>
    )
}